import {AfterViewChecked, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {filter, switchMap} from 'rxjs/operators';
import {InsightPopupService} from '../insight-popup.service';
import {
    LEARNING_PROGRESS_INSIGHT,
    LearningProgressInsightService
} from '../../../../services/LearningProgressInsightService';
import {TAB_NAVIGATION_SERVICE, TabNavigationService} from '../../../../services/TabNavigationService';

@Component({
    selector: 'mm-skill-profile-popup',
    templateUrl: './skill-profile-popup.component.html',
    styleUrl: './skill-profile-popup.component.scss',
    standalone: false
})
export class SkillProfilePopupComponent implements AfterViewChecked {
    @ViewChild('scrollContainer')
    public scrollContainer: ElementRef<HTMLDivElement> | undefined;

    private previousScrollWidth = 0;
    private previousClientWidth = 0;


    constructor(public insightPopupService: InsightPopupService,
                @Inject(LEARNING_PROGRESS_INSIGHT) private learningProgressInsightService: LearningProgressInsightService,
                @Inject(TAB_NAVIGATION_SERVICE) public tabNavigationService: TabNavigationService) {
    }

    public skillsProfileData$ = this.insightPopupService.selectedLearningPackageId$.pipe(
        filter((learningPackageId): learningPackageId is string => learningPackageId !== undefined),
        switchMap((learningPackageId: string) => this.learningProgressInsightService.getSkillsProfileInsightHistory(learningPackageId))
    );

    public ngAfterViewChecked(): void {
        this.centerScroll();
    }

    private centerScroll(): void {
        if (this.scrollContainer !== undefined) {
            const element = this.scrollContainer.nativeElement;
            const scrollWidth = element.scrollWidth;
            const clientWidth = element.clientWidth;
            const sizeChanged = this.previousScrollWidth !== scrollWidth ||
                this.previousClientWidth !== clientWidth;

            if (sizeChanged) {
                element.scrollLeft = (scrollWidth - clientWidth) / 2;
                this.previousScrollWidth = scrollWidth;
                this.previousClientWidth = clientWidth;
            }
        }
    }
}
